<!-- 新建/编辑地标管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="地标名称" prop="name">
              <div class="list-img-box">
                <el-input placeholder="请输入地标名称" v-model="formValidate.name"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="城市" prop="cityId">
              <div class="list-img-box">
                <el-select v-model="formValidate.cityId" placeholder="请选择城市" :style="{width:'100%'}">
                   <el-option v-for="item in this.$route.query.cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-form>
          <!-- 保存 -->
          <div :style="{textAlign:'center'}">
            <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
            <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'LocationManagementOperation',
    data () {
      return {
        formValidate: {
          name: '',//添加地标名称
          cityId: '',//添加城市名称
        },
        ruleValidate: { //学校非空验证
          name: [
            { required: true, message: '请输入地标名称', trigger: 'blur'}
          ],
          cityId: [
            { required: true, message: '请选择城市名称', trigger: 'change'}
          ],
        },
      }
    },
    methods: {
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.$route.query.data == undefined){
                params = {
                  name:this.formValidate.name,
                  cityId:this.formValidate.cityId,
                  status:1
                }
              } else {
                params = {
                  id:this.$route.query.data.id,
                  cityId:this.formValidate.cityId,
                  name:this.formValidate.name,
                  status:1
                }
                title = "编辑";
              }
              this.$api.saveOrUpdateLandmark({parameter: JSON.stringify(params)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/LocationManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/LocationManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.name = this.$route.query.data.name;
        this.formValidate.cityId = this.$route.query.data.cityId;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/LocationManagementOperation.vue